import { gql, useQuery } from '@apollo/client';

import {
  VirtualAssessment,
  VirtualAssessmentVariables,
} from '../../../graphql/athena/queries/__generated__/VirtualAssessment';

export const VirtualAssessmentQuery = gql`
  query VirtualAssessment($sellerInputUUID: String!) {
    sellDirect {
      getLead(input: { lead: { source: { type: RECEPTION, id: $sellerInputUUID } } }) {
        lead {
          latestSelfServeVirtualAssessmentId
          latestSelfServeVirtualAssessment {
            ssva {
              state
            }
            ssvaCompletedAt
            id
            ssvaRecordingsSubmitted
            ssvaQuestionnaireSubmitted
            ssvaInteriorRecordingsSubmitted
            ssvaBackyardRecordingsSubmitted
            ssvaFrontyardRecordingsSubmitted
            ssvaSellerDisclosureDocumentRecordingsSubmitted
            ssvaRecordings {
              id
              recordedFeature
              fileName
              s3Directory
              preSignedRecordingUrl
            }
          }
        }
      }
    }
    web {
      getAllExteriorAssessmentSlots(sellerInputUUID: $sellerInputUUID) {
        currentInspectionTime
      }
    }
  }
`;

/** Calls for data for the different VA types */
export const useVirtualAssessmentData = (sellerInputUUID: string) => {
  const { data, ...rest } = useQuery<VirtualAssessment, VirtualAssessmentVariables>(
    VirtualAssessmentQuery,
    {
      context: {
        clientName: 'athena',
      },
      variables: { sellerInputUUID },
      fetchPolicy: 'cache-first',
    },
  );
  const details = {
    latestSelfServeVirtualAssessment:
      data?.sellDirect.getLead?.lead?.latestSelfServeVirtualAssessment,
    latestSelfServeVirtualAssessmentId:
      data?.sellDirect.getLead?.lead?.latestSelfServeVirtualAssessmentId,
    ssvaWebState: data?.sellDirect.getLead?.lead?.latestSelfServeVirtualAssessment?.ssva?.state,
    // To see if they scheduled home assessment
    isHaScheduled: Boolean(data?.web.getAllExteriorAssessmentSlots?.currentInspectionTime),
  };
  return { details, ...rest };
};
